module.exports = __webpack_public_path__ + "img/product_stat1.379d49a4.png";